import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Modal from './modal/modal';
import NewModal from './new-modal/new-modal';
import modalActions from './modal-actions';

/**
 * ModalContainer Redux component
 * Responsible for managing the display of modals in the app
 *
 */
export const ModalContainer = ({ modalMessages, closeModal }) => (
    <div>
        {
            modalMessages.modalData.map(message => (
                modalMessages.useNewModal ?
                    <NewModal
                        key={message.id}
                        message={message}
                        onClose={closeModal}
                    /> : <Modal
                        key={message.id}
                        message={message}
                        onClose={closeModal}
                    />
            ))
        }
    </div>
);

ModalContainer.propTypes = {
    modalMessages: PropTypes.object,
    closeModal: PropTypes.func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        modalMessages: state.modalMessages
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeModal: modalActions.closeModal
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);



// WEBPACK FOOTER //
// ./components/modal/modal-container.js